import React, { Component } from "react";
import classnames from "classnames";
import "./OpSelect.scss";
import { ReactComponent as Sorting } from "./../../assets/images/sorting.svg";
import { ReactComponent as Cross } from "./../../assets/images/cross.svg";

export const CLASS_FOCUSED = "is-focused";
export const CLASS_OPENED = "is-opened";
export const CLASS_HAS_VALUE = "is-has-value";
export const CLASS_OPTION_NOVALUE = "is-option-no-value";
export const CLASS_OPTION_SELECTED = "is-option-selected";
export const CLASS_SELECT_SIMPLE = "is-select-simple";

export default class OpSelect extends Component {
	static defaultProps = {
		suggestions: [],
	};
	opened = false;
	state = {
		opened: false,
		focused: false,
		selected: this.props.selected,
	};
	search = {
		char: "",
		started: false,
		timeout: null,
		delay: 300,
	};
	listItems = {};
	ul = null;
	select = null;
	constructor(props) {
		super(props);
		this.select = React.createRef();
		this.ul = React.createRef();
		this.changeEvent = document.createEvent("Event");
		this.changeEvent.initEvent("change", true, true);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.state.opened === false && prevState.opened === true) {
			if (this.props.handleChange) {
				this.props.handleChange(this.state.selected, prevState.selected);
			}
		}

		if (this.isMobile() && this.state.selected !== prevState.selected) {
			if (this.props.handleChange) {
				this.props.handleChange(this.state.selected, prevState.selected);
			}
		}
		if (
			this.props.selected !== prevProps.selected &&
			this.props.selected !== this.state.selected
		) {
			if (this.props.selected) {
				this.setState({
					selected: this.props.selected,
				});
			} else if (
				this.props.selected !== prevProps &&
				this.props.selected === null
			) {
				this.setState({ selected: null });
			}
		}
	}

	render() {
		const {
			name,
			placeholder,
			getValue,
			getLabel,
			options,
			useIconMobile,
			allowEmpty = false,
		} = this.props;
		const { opened, focused, selected } = this.state;
		let selectedObject = selected;

		// let reOrderedOptions = this.getReorderedOptions();
		let isMobile = this.isMobile();
		return (
			<div
				className={classnames("op-select", {
					[CLASS_FOCUSED]: focused,
					[CLASS_SELECT_SIMPLE]: isMobile,
					"op-select--use-icon-mobile": useIconMobile,
				})}
				tabIndex={0}
				onFocus={this.onFocus}
				onBlur={this.onBlur}
				onKeyDown={this.onKeydown}>
				{/*<div className="op-select__placeholder">{placeholder}</div>*/}
				<x-selected class="op-select__text" onClick={this.open}>
					<span>{selectedObject ? getLabel(selectedObject) : placeholder}</span>
					{allowEmpty && selectedObject && !opened ? (
						<button
							className={"op-select__empty-selection"}
							onClick={this.deselect}>
							<Cross />
						</button>
					) : null}
				</x-selected>
				<x-selected class="op-select__icon" onClick={this.open}>
					<Sorting />
				</x-selected>
				<select
					ref={this.select}
					name={name}
					onChange={this.onChange}
					value={selectedObject ? getValue(selectedObject) : undefined}>
					{options.map((option) => (
						<option key={getValue(option)} value={getValue(option)}>
							{getLabel(option)}
						</option>
					))}
				</select>
				{!isMobile ? (
					<div
						className={classnames({
							"op-select__dropdown": true,
							[CLASS_OPENED]: opened,
							[CLASS_HAS_VALUE]: selectedObject
								? !!getValue(selectedObject)
								: false,
						})}>
						<ul ref={this.ul}>
							{options.map((option, i) => (
								<li
									ref={(ref) => {
										this.listItems[getValue(option)] = ref;
									}}
									key={getValue(option)}
									onClick={() => this.clickItem(option, i)}
									className={classnames({
										[CLASS_OPTION_SELECTED]:
											selectedObject &&
											getValue(selectedObject) === getValue(option),
									})}>
									{getLabel(option)}
								</li>
							))}
						</ul>
					</div>
				) : null}
			</div>
		);
	}

	isMobile() {
		return false;
		// return navigator.userAgent.match(/(iPod|iPhone|iPad|Android|BlackBerry)/);
	}

	// getReorderedOptions() {
	// 	const { options } = this.props;
	// 	let optionsWithoutSelected = options.filter(
	// 		(option) => option !== this.props.selected
	// 	);
	// 	return [this.props.selected].concat(optionsWithoutSelected);
	// }

	onFocus = () => {
		this.focus();
	};

	onBlur = () => {
		this.unfocus();
		this.close(true);
	};

	onChange = () => {
		// let reOrderedOptions = this.getReorderedOptions();
		const { options } = this.props;
		const selectedIndex = this.select.current.selectedIndex;
		// console.log(reOrderedOptions[selectedIndex]);
		this.setState({ selected: options[selectedIndex] });
	};

	onKeydown = (e) => {
		// Esc keydowm
		if (e.which === 27) {
			this.onEsc(e);
			return;
		}
		// input was 0-9 // input was a-z
		if (
			(e.keyCode >= 48 && e.keyCode <= 57) ||
			(e.keyCode >= 65 && e.keyCode <= 90)
		) {
			this.onChar(e);
			return;
		}

		// arrows
		if (e.which === 38 || e.which === 40) {
			this.onArrow(e);
			return;
		}

		// enter
		if (e.which === 13) {
			this.onEnter(e);
			return;
		}
	};

	onEsc = (e) => {
		e.preventDefault();
		this.close(true);
	};

	onChar = (e) => {
		if (!this.search.started) {
			this.search.started = true;
		} else {
			window.clearTimeout(this.search.timeout);
		}

		this.search.timeout = window.setTimeout(() => {
			this.search.char = "";
			this.search.started = false;
		}, this.search.delay);

		this.search.char += e.key;
		this.searchChar();
	};

	onArrow = (e) => {
		if (!this.state.opened) {
			e.preventDefault();
			this.open();
			return;
		}

		// Up
		if (e.keyCode === 38) {
			e.preventDefault();
			const { options } = this.props;
			// let reOrderedOptions = this.getReorderedOptions();
			let currentIndex = options.indexOf(this.state.selected);
			let selectedIndex = Math.max(currentIndex - 1, 0);
			this.setState({ selected: options[selectedIndex] }, () => {
				this.scrollToSelected();
			});
		}

		// Down
		else if (e.keyCode === 40) {
			e.preventDefault();
			// let reOrderedOptions = this.getReorderedOptions();
			const { options } = this.props;
			let currentIndex = options.indexOf(this.state.selected);
			let selectedIndex = Math.min(currentIndex + 1, options.length - 1);
			this.setState({ selected: options[selectedIndex] }, () => {
				this.scrollToSelected();
			});
		}
	};

	onEnter = (e) => {
		e.preventDefault();
		if (!this.state.opened) {
			this.open();
		} else {
			this.close();
		}
	};

	searchChar() {
		if (this.search.char === "") return;
		for (let i = 0; i < this.props.options.length; i++) {
			if (
				this.props
					.getLabel(this.props.options[i])
					.toLowerCase()
					.startsWith(this.search.char.toLowerCase())
			) {
				this.setState({ selected: this.props.options[i] }, () => {
					this.scrollToSelected();
				});

				break;
			}
		}
	}

	clickItem = (selected, index) => {
		this.setState({ selected: selected }, () => {
			this.close();
		});
	};

	focus() {
		this.setState({ focused: true });
	}

	unfocus() {
		this.setState({ focused: false });
	}

	open = () => {
		if (this.state.opened) {
			this.close(true);
			return;
		}
		if (this.props.overlayActivate) {
			this.props.overlayActivate();
		}
		this.setState({ opened: true, lastSelected: this.state.selected }, () => {
			this.scrollToSelected();
		});
	};

	close = (restore = false) => {
		if (!this.state.opened) return;
		if (this.props.overlayActivate) {
			this.props.overlayDeactivate();
		}
		let newState = { opened: false };
		if (restore) {
			newState.selected = this.state.lastSelected;
		}
		this.setState(newState, () => {
			this.ul.current.scrollTop = 0;
		});
		// Important for Firefox
	};

	deselect = (e) => {
		e.preventDefault();
		e.stopPropagation();
		let prevSelected = this.state.selected;
		this.setState({ selected: null });
		if (this.props.handleChange) {
			this.props.handleChange(null, prevSelected);
		}
	};

	scrollToSelected() {
		if (!this.state.opened || this.props.options.length === 0) return;
		let selectedObject = this.state.selected
			? this.state.selected
			: this.props.default;
		if (!selectedObject) return;
		this.ul.current.scrollTop = 0;
		const ulRect = this.ul.current.getBoundingClientRect();
		const liRect = this.listItems[
			this.props.getValue(selectedObject)
		].getBoundingClientRect();
		const scrollDist =
			liRect.top - ulRect.top - ulRect.height / 2 + liRect.height / 2;
		this.ul.current.scrollTop = scrollDist < 0 ? 0 : scrollDist;
	}
}
